module.exports = __webpack_public_path__ + "static/media/test12_4.69f46a64.png";